import BaseColors from '@/atoms/colors/Base';
import Box from '@mui/material/Box';
import SelectColors from '../colors/Select';

const SelectItem = ({
  children,
  color = 'secondary',
  isFocus,
  onClick,
  onFocus,
  value,
}) => {
  const handleKeyDown = (event) => {
    if (event.key == 'Enter') {
      onClick?.(event, value);
    }
  };

  return (
    <Box
      onKeyDown={handleKeyDown}
      onClick={onClick}
      onFocus={onFocus}
      tabIndex={0}
      p={0.5}
      m={0}
      sx={{
        ...SelectColors.option[color].normal,
        boxShadow: `inset 0 -1px 0 0 ${SelectColors.option.primary.normal.borderColor}77`,
        backgroundColor: 'transparent',
        color: BaseColors.font.primary,
        fontSize: '0.85rem',
        lineHeight: '1.25rem',
        '&:focus': {
          outline: 'none',
        },
        '&:last-child': {
          boxShadow: 'none',
        },
      }}
    >
      <Box
        pl={1}
        pr={2}
        py={0.5}
        sx={{
          backgroundColor: isFocus
            ? SelectColors.option[color].focus.backgroundColor
            : null,
          '&:hover, &:focus': {
            ...SelectColors.option[color].hover,
            cursor: 'pointer',
          },
          '&:focus': {
            outline: 'none',
            boxShadow: `inset 0 0 0 1px ${SelectColors.option[color].focus.borderColor}`,
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default SelectItem;
